import type {InvoiceStatusDraft} from './types';
import {InvoiceStatusActionType} from './types';

const updateInvoiceStatusReducer = (
  state: InvoiceStatusDraft,
  action: {
    type: InvoiceStatusActionType;
    payload: Partial<InvoiceStatusDraft>;
  },
): InvoiceStatusDraft => {
  switch (action.type) {
    case InvoiceStatusActionType.UPDATE_INVOICE_STATUS:
      return {...state, ...action.payload};

    case InvoiceStatusActionType.RESET_INVOICE_STATUS:
      return {...action.payload} as InvoiceStatusDraft;

    default:
      return state;
  }
};

export default updateInvoiceStatusReducer;
